import script from "./TaskTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskTable.vue?vue&type=script&setup=true&lang=js"

import "./TaskTable.vue?vue&type=style&index=0&id=7c4dc7bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c4dc7bb"]])

export default __exports__